import MuiDialogContent, { DialogContentProps as MuiDialogContentProps } from '@mui/material/DialogContent'
import React from 'react'

const Body = ({ children, ...rest }: MuiDialogContentProps): React.ReactElement => (
  <MuiDialogContent {...rest}>
    {children}
  </MuiDialogContent>
)

export default Body
